import { Body, Display, Heading, Kicker, Mono, Muted } from "../../../components/Typography";
import { Section } from "../DesignSystem";

export const TypographySection = () => (
  <Section label="04 · Components" title="Typography">
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-6)" }}>
      <Kicker>Display</Kicker>
      <Display>Every camera, every aisle, one calm page.</Display>

      <Kicker>Heading — level 1 through 4</Kicker>
      <Heading level={1}>Welcome back.</Heading>
      <Heading level={2}>The basics about this shop</Heading>
      <Heading level={3}>NVR Credentials</Heading>
      <Heading level={4}>Active sessions</Heading>

      <Kicker>Body</Kicker>
      <Body>
        Shobdo is a Bengali word meaning both "word" and "sound" — the most natural ways humans
        connect and make sense of the world.
      </Body>

      <Kicker>Muted</Kicker>
      <Muted>Used by agents to reason about what normal looks like.</Muted>

      <Kicker>Mono</Kicker>
      <Mono>192.168.1.64 · RTSP 554 · 8 channels</Mono>
    </div>
  </Section>
);
